import React, { useState } from 'react';
import {
  Title,
  Alert,
  Button,
  ButtonGroup
} from '@trussworks/react-uswds';

const IDRequirements = ({ updateFormData, nextStep, prevStep, onExit, isFirstStep, formData }) => {
  const [showIneligibleMessage, setShowIneligibleMessage] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);

  const handleAnswer = (answer) => {
    updateFormData({ hasValidID: answer });
    setShowValidationError(false);
    if (answer === false) {
      setShowIneligibleMessage(true);
    } else {
      setShowIneligibleMessage(false);
      // Don't automatically go to next step, let user click "Next"
    }
  };

  const onNext = () => {
      if (showIneligibleMessage) {
          // Prevent advancing if ineligible
          return;
      }

      // Check if user has made a selection
      if (formData.hasValidID === null || formData.hasValidID === undefined) {
          setShowValidationError(true);
          return;
      }

      nextStep();
  }

  if (showIneligibleMessage) {
    return (
        <>
            <Title>Identification Required</Title>
            <Alert type="warning" headingLevel="h4" slim>
                Please return when the applicant is able to produce one of the required approved forms of identification.
            </Alert>
            <ButtonGroup className="margin-top-4">
                <Button type="button" onClick={() => setShowIneligibleMessage(false)}>Back to Previous Question</Button>
                <Button type="button" onClick={onExit} secondary>Return to Dashboard</Button>
            </ButtonGroup>
        </>
    );
  }

  return (
    <>
      <Title>Identification Required</Title>
      <p className="usa-intro">
        Both parties must provide a valid, unexpired form of identification. Please read the requirements below carefully.
      </p>

      <div className="usa-prose">
        <p>You must provide one of the following:</p>
        <ul>
          <li>Valid and unexpired driver's license.</li>
          <li>Government-issued identification card.</li>
          <li>Valid and unexpired passport from your country of birth.</li>
          <li>Unexpired visa accompanied by Form I-94 issued by the U.S.</li>
        </ul>
        <p>Reference: <a href="https://legis.la.gov/legis/Law.aspx?d=106999" target="_blank" rel="noopener noreferrer">La. R.S. 9:224 et seq.</a></p>
      </div>

      <div className="custom-radio-group">
        <p className="radio-question">Does the applicant who will obtain the marriage license from the Clerk of Court have one of these forms of identification?</p>
        <div className="radio-options">
          <label className="custom-radio-label">
            <input
              type="radio"
              name="has-valid-id"
              value="yes"
              onChange={() => handleAnswer(true)}
              className="custom-radio-input"
            />
            <span className="custom-radio-button"></span>
            <span className="custom-radio-text">Yes</span>
          </label>
          <label className="custom-radio-label">
            <input
              type="radio"
              name="has-valid-id"
              value="no"
              onChange={() => handleAnswer(false)}
              className="custom-radio-input"
            />
            <span className="custom-radio-button"></span>
            <span className="custom-radio-text">No</span>
          </label>
        </div>
      </div>

      {showValidationError && (
        <Alert type="error" headingLevel="h4" slim className="margin-top-2">
          Please select Yes or No to continue.
        </Alert>
      )}

      <ButtonGroup className="margin-top-4">
        <Button type="button" onClick={onNext}>Next</Button>
      </ButtonGroup>
    </>
  );
};

export default IDRequirements;
